import { FC, ReactNode } from 'react';
import styles from './OffersList.css';

interface IOffersListProps {
  filters: ReactNode;
  list: ReactNode;
  allOffersLinkButton: ReactNode;
}

export const OffersList: FC<IOffersListProps> = ({ filters, list, allOffersLinkButton }) => {
  return (
    <div>
      <div className={styles['filters']}>{filters}</div>
      {list}
      <div className={styles['all-offers-button']}>{allOffersLinkButton}</div>
    </div>
  );
};
